import React, {useState, useEffect} from 'react';
import {Grid , Chip, Typography, List, ListItem, ListItemIcon, ListItemText, Divider, Paper} from '@material-ui/core/';
import {NavigateNext} from '@material-ui/icons';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {Today, LocationOn, HomeWork } from '@material-ui/icons';

function DatosCiudadano(props) {   
    const classes = useStyles()

    return (
        <Grid container className={classes.marginBotton}>
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>DATOS DEL EMPADRONADOR</strong> <Divider /></div>
            </Grid >
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="Nombre Empadronador: " />
                        <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                    </ListItem>
                </Grid>
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={props.datosEmpadronador.nombreUsuario} />                                
                </Grid>
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="Lugar del Puesto de Empadronamiento: " />
                        <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                    </ListItem>
                </Grid >
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={props.datosEmpadronador.nombreDepartamentoEmpadronamiento+', '+props.datosEmpadronador.nombreMunicipioEmpadronamiento} />                                
                </Grid >
                <Grid item xs={3}>
                    <ListItem className={classes.rootListItem}>
                        <ListItemText className={classes.rootListItemText} primary="Puesto de Empadronamiento: " />
                        <ListItemIcon className={classes.colorIcon}><HomeWork/></ListItemIcon>
                    </ListItem>
                </Grid>
                <Grid item xs={3}>
                    <Chip variant="outlined" className={classes.colorChip} label={props.datosEmpadronador.nombrePuestoEmpadronamiento} />                                
                </Grid>                                 
        </Grid>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadano);